import { DefaultPalette } from '@fluentui/style-utilities/lib';
import { getPalette } from 'owa-theme';
import type { IButtonStyles } from '@fluentui/react/lib/Button';
import type { RecurrenceDaysColor } from '../components/RecurrenceDaysComponent';

export function onDayButtonClicked(
    daySelected: string,
    days: string[],
    onDaySelectionChangedCallback: any
) {
    // User needs to select at least one day. This will prevent no days being selected.
    if (days.length == 1 && days.includes(daySelected)) {
        onDaySelectionChangedCallback(days);
        return;
    }

    if (days.includes(daySelected)) {
        let index = days.indexOf(daySelected);
        days.splice(index, 1);
    } else {
        days.push(daySelected);
    }

    onDaySelectionChangedCallback(days);
}

export function getButtonStyle(colors: RecurrenceDaysColor) {
    let themeSymbols = getPalette();

    return {
        root: {
            color: DefaultPalette.neutralDark,
            backgroundColor: DefaultPalette.neutralLight,
        },

        rootHovered: {
            color: DefaultPalette.neutralDark,
            backgroundColor: DefaultPalette.neutralQuaternaryAlt,
        },

        rootPressed: {
            color: DefaultPalette.white,
            backgroundColor: colors ? colors.checkedColor : themeSymbols.themePrimary,
        },

        rootChecked: {
            color: DefaultPalette.white,
            backgroundColor: colors ? colors.checkedColor : themeSymbols.themePrimary,
        },

        rootCheckedHovered: {
            color: DefaultPalette.white,
            backgroundColor: colors ? colors.checkedHoverColor : themeSymbols.themeDark,
        },

        rootCheckedPressed: {
            border: 'solid 1px ' + DefaultPalette.white,
        },
    } as IButtonStyles;
}
